<template>
    <div style="margin-bottom: 140px">
    <div v-if="!loaded">
      <img src="@/assets/loading.svg" style="width: 34px;">
    </div>
        <AddToCart v-if="showAddProductModal" v-on:close="closeAddToCartModal()"/>
        <div style="display: flex;flex-wrap: wrap;" v-if="loaded">
            <div class="beverage-box" v-for="beverage in beverages" :key="beverage.id">
                <div>
                    <img :src="beverage.thumbnail" :alt="beverage.title" style="width: 100%;height: 100%;border-radius: 8px;">
                </div>
                <div class="beverage-box-title-section">
                    <div class="beverage-box-title" v-html="beverage.title"></div>
                    <div class="beverage-box-description">
                        {{ beverage.volume }} ml
                    </div>
                </div>

                <div style="margin-top: 14px;text-align: left;display: flex;flex-direction: column;justify-content: space-between;align-items: baseline;">
                    <div class="beverage-box-price">{{ beverage.price }} грн</div>
                    
                    <button class="add-to-card-button" @click="showAddToCardModal(beverage)">В кошик</button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import AddToCart from '@/components/AddToCart.vue'
    export default {
        components: {
            AddToCart
        },
        data() {
            return {
                beverages: [],
                showAddProductModal: false,
                loaded: false
            }
        },

        methods: {
            showAddToCardModal(beverage) {
                window.scrollTo(0, 0);
                this.$store.commit('setCurrentProduct', beverage);

                document.querySelector('body').style.overflow = 'hidden';
                this.showAddProductModal = true;
            },

            closeAddToCartModal() {
                document.querySelector('body').style.overflow = '';
                this.showAddProductModal = false;
            }
        },

        mounted() {
            this.$store.dispatch('getBeverages').then(beverages => {
                this.beverages = beverages;
                this.loaded = true;
            });
        }
    }
</script>

<style>
    .beverage-box {
        position: relative;

        width: 100%;
        max-width: 280px;
        height: 450px;

        margin-right: 14px;
        margin-bottom: 14px;
        padding: 14px;
        border: 1px solid white;
        border-radius: 8px;
    }

    .beverage-box:hover {
        box-shadow: 0 2px 40px 0 rgba(0, 0, 0, .12);
    }

    .beverage-box-title-section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: baseline;
    }

    .beverage-box-title {
        font-size: 1.2rem;
        font-weight: 700;
        text-align: center;
    }

    .beverage-box-description {
        margin-top: 7px;
        text-align: left;
        font-weight: bold;
        color: #AB2321;
    }

    .beverage-box-price {
        font-size: 1.2rem;
        font-weight: bold;
        color: #AB2321;
    }

    .beverage-box .add-to-card-button {
        width: 100%;
        margin-top: 12px;
        padding: .375rem .75rem;
        border: 1px solid #AB2321;

        background-color: #AB2321;
        color: #fff;
        border-radius: 6px;
    }
</style>